import React from "react";
import videoIntro from "../../Assets/Images/Image/h2-intro-video1 (1) (1).webp";
import { Link } from "react-router-dom";
import arrow from "../../Assets/Images/Icons/right-arrow.png";
import about from "../../Assets/Styles/Home/about.module.css";
import icon from "../../Assets/Images/Icons/.png";
import Fade from "react-reveal/Fade";

const About = () => {
  return (
    <Fade bottom>
      <section className="max-lg:my-[150px] my-[60px]  ">
        <div className=" px-[20px] max-lg:p-0 2xl:max-w-[1420px] max-xl:max-w-[1150px]  overflow-hidden  mx-auto flex-col max-lg:flex-row flex justify-center items-center">
          <div
            className={`max-sm:max-w-[394px]  mx-auto ${about.about_intro_video}`}
          >
            <div>
              <img src={videoIntro} alt="IT Ghar Video Intro Section" />
            </div>
            <button>
              <i className="fa fa-play"></i>
            </button>
          </div>
          <div className=" max-lg:px-0 mt-10 max-lg:mt-0 text-left max-lg:w-1/2">
            <button className="custom_button2">
              <span>About Our Conpany ~</span>
            </button>
            <h2 className=" mb-[28px] leading-[38px]  max-sm:leading-[1.1428] text-[#1E1B18] font-fira font-bold text-[25px] max-sm:text-[42px]">
              All Technology Solutions
              <br /> With <span className="text-primary"> Reliability</span>
            </h2>
            <p className="text-[#6A6D7A]  mb-5 max-lg:mb-10  font-roboto text-justify text-[17px] leading-6 max-lg:leading-[32px] font-normal">
              At IT Ghar, we are a premier provider of IT solutions that
              prioritize speed, innovation, and quality. By leveraging
              technology, we aim to drive growth for our client's businesses. We
              take pride in our strong work ethic, unwavering integrity, and
              exceptional results.
            </p>
            <div className="mb-10">
              <p className="flex gap-3  items-center">
                <img className="w-[20px] h-[20px]" src={icon} alt="icons" />
                <span className="text-[#1E1B18] text-[12px] max-lg:text-xl font-semibold max-lg:font-medium">
                  Accurate and friendly support
                </span>
              </p>
              <p className="flex gap-3 my-3  items-center">
                <img className="w-[20px] h-[20px]" src={icon} alt="icons" />
                <span className="text-[#1E1B18] text-[12px] max-lg:text-xl font-semibold max-lg:font-medium">
                  Cultivate new and revolutionary ideas
                </span>
              </p>
              <p className="flex gap-3  items-center">
                <img className="w-[20px] h-[20px]" src={icon} alt="icons" />
                <span className="text-[#1E1B18] text-[12px] max-lg:text-xl font-semibold max-lg:font-medium">
                  Believes in research and continuous development
                </span>
              </p>
            </div>
            <div className="flex mb-3 gap-10 max-sm:gap-0 max-sm:flex-row flex-col max-sm:max-w-[450px] justify-between ">
              <Link to="/contact">
                <button className="custom_button flex justify-center items-center ">
                  {" "}
                  Contact Us <img
                    className="ml-2"
                    src={arrow}
                    alt="IT Ghar"
                  />{" "}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default About;
